import { api, type Items } from '@sentinel/web-core';
import type {
  Drone,
  DroneCreate,
  DroneStreamKey,
  DroneUpdate,
  DroneVideo,
  PilotLinkCode,
  PilotSession,
  PilotToken,
} from '@sentinel/shared';

/** Droni (T-08): drones of the organization, stream key for DJI Pilot 2, video. */
export const droneEndpoints = {
  list: () => api<Items<Drone>>('/drones'),
  create: (body: DroneCreate) => api<Drone>('/drones', { method: 'POST', body }),
  update: (id: string, body: DroneUpdate) => api<Drone>(`/drones/${id}`, { method: 'PATCH', body }),
  issueStreamKey: (id: string) =>
    api<DroneStreamKey>(`/drones/${id}/stream-key`, { method: 'POST' }),
  openVideo: (id: string) => api<DroneVideo>(`/drones/${id}/video`, { method: 'POST' }),
  /** DJI Pilot 2 linked to Sentinel (ADR 0017): the code from the Control Center, then what
   *  the page on the controller trades it for. */
  pilotCode: (id: string) => api<PilotLinkCode>(`/drones/${id}/pilot-code`, { method: 'POST' }),
  pilotEnrol: (code: string) =>
    api<PilotToken>('/dji/pilot/enrol', { method: 'POST', body: { code } }),
  pilotSession: (token: string) =>
    api<PilotSession>('/dji/pilot/session', { method: 'POST', body: { token } }),
};
